export const ExportIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.5 3.35714C2.5 2.33147 3.32081 1.5 4.33333 1.5H11.6667C12.6792 1.5 13.5 2.33147 13.5 3.35714V12.6429C13.5 13.6686 12.6792 14.5 11.6667 14.5H8.91667V10.7857H11.6667L8 7.07143L4.33333 10.7857H7.08333V14.5H4.33333C3.32081 14.5 2.5 13.6686 2.5 12.6429V3.35714Z'
      fill='inherit'
    />
  </svg>
);
